import { Box } from "@mui/system";
import { BarChart } from "@mui/x-charts/BarChart";

interface Props {
  uploadedToPlatformsData: any[];
  advertisingPlatformsData: any[];
  setClickedTraffic: any;
}

export default function AllAdsBarChart({
  uploadedToPlatformsData,
  advertisingPlatformsData,
  setClickedTraffic,
}: Props) {
  // Count uploaded conversions (Reported)
  const reported = uploadedToPlatformsData?.reduce((acc: any, curr: any) => {
    acc[curr.traffic_source] = (acc[curr.traffic_source] || 0) + 1;
    return acc;
  }, {});

  // Conversions appearing
  const appearing = advertisingPlatformsData?.reduce((acc: any, curr: any) => {
    acc[curr.traffic_source] = Math.round(curr?.conversions_uploaded || 0);
    return acc;
  }, {});

  // Platforms mapping
  const platforms = [
    { key: "g_ads_search", label: "Google Ads" },
    { key: "bing_ads_search", label: "Bing Ads" },
    { key: "meta_ads", label: "Meta Ads" },
    { key: "incentivezed_traffic", label: "Incentivized" },
  ];

  // X-axis labels
  const categories = platforms.map((p) => p.label);

  // Series: Reported vs Appearing
  const reportedSeries = platforms.map((p) => reported?.[p.key] || 0);
  const appearingSeries = platforms.map((p) => appearing?.[p.key] || 0);

  return (
    <Box width="514px" height={216}>
      <BarChart
        xAxis={[{ data: categories, scaleType: "band" }]}
        series={[
          {
            label: "Reported",
            data: reportedSeries,
            color: "rgba(76, 175, 80, 0.8)",
          },
          {
            label: "Appearing",
            data: appearingSeries,
            color: "rgba(239, 83, 80, 0.8)",
          },
        ]}
        onItemClick={(_event, item) => {
          // item contains seriesId + dataIndex
          const index = item.dataIndex;
          setClickedTraffic([platforms[index]?.key]);
        }}
        height={240} // a bit more height for breathing space
        leftAxis={null}
        rightAxis={{}}
        margin={{ top: 16, right: 32, bottom: 60, left: 16 }} // ⬅️ increased bottom margin for legend
        grid={{ vertical: false, horizontal: true }}
        barLabel="value"
        sx={{
          [`& .MuiChartsAxis-tickLabel`]: {
            fill: "grey !important", // ✅ tick labels grey
          },
          [`& .MuiChartsAxis-tick`]: {
            display: "none", // ✅ hide tick lines
          },
          [`& .MuiChartsLegend-root text`]: {
            fill: "grey !important", // ✅ legend text grey
          },
          [`& .MuiChartsAxis-line`]: {
            display: "none",
          },
          [`& .MuiChartsBar-labels text`]: {
            fill: "#fff !important", // ✅ force bar label text white
            fontWeight: 600,
          },
        }}
        slotProps={{
          legend: {
            direction: "row",
            position: {
              vertical: "bottom",
              horizontal: "middle",
            },
            labelStyle: {
              fontSize: 12,
              fontWeight: 500,
            },
            itemMarkWidth: 14,
            itemMarkHeight: 14,
            markGap: 8,
            itemGap: 16,
            padding: 0,
          },
        }}
      />
    </Box>
  );
}
